// 国内水运
export const DomesticMarineTransportationZh = {
  // 中文
  DataStatistics: '数据统计',
  OrderInquiry: '订单查询',
  SubscriptionCenter: '订阅中心',
  CurrentMonth: '当月度',
  CurrentQuarter: '当季度',
  CurrentYear: '当年度',
  Loaded: '已装货',
  Sailed: '已开航',
  Sailed2: '开航',
  ArrivedatPort: '已到港',
  ArrivedatPort2: '到港',
  Delivered: '已送货',
  Delivered2: '送货',
  NumberOfTransactions: '业务数量',
  vote: '票',
  QuantityofContainers: '箱量',
  BusinessStatistics: '业务统计',
  DestinationPortNumberofShipments: '目的港(票)',
  ContainerStatistics: '箱量统计',
  DestinationPortQuantityofContainers: '目的港(箱量)',
  JobNo: '我司编码',
  PleaseEnterContent: '请输入内容',
  CustomerCode: '客户编码',
  OrderRange: '下单区间',
  WaterwayShippingNumber: '水运单号',
  ContainerType: '箱型',
  ContainerNumber: '箱号',
  ContainerType2: '箱型箱量',
  Search: '查询',
  Reset: '重置',
  Export: '导出',
  DetailView: '明细查看',
  OrderNumber: '我司编码',
  OrderNumber2: '订单号',
  BusinessType: '运输模式',
  MM: 'MM(内贸水运)',
  OrderTime: '下单时间',
  Collapse: '收起',
  LoadingPortInformation: '起运港信息',
  DestinationPortInformation: '目的港信息',
  CargoInformation: '货物信息',
  DownloadAttachment: '下载附件',
  FileName: '文件名',
  Creator: '创建人',
  CreationTime: '创建时间',
  Operation: '操作',
  Download: '下载附件',
  Cancel: '取消',
  LoadingPort: '起运港',
  DestinationPort: '目的港',
  TotalNumberofPieces: '总件数',
  TotalNumberofPiecesUnit: '件数单位',
  ProductNameContainerTypeQuantityofContainers: '品名箱型箱量',
  GrossWeightKGS: '毛重(KGS)',
  VolumeCBM: '体积(CBM)',
  OrderReceived: '接单',
  Packed: '已装箱',
  Packed2: '装箱',
  SearchErr: '查询失败',
  Switch: '切换',
  MMOrderDetial: '海运_内贸水运',
  Containers: '箱型箱量',
  Goods: '品名',
  Goods2: '品名',
  SerialNumber: '序号',
  OrderStatus: '订单状态',
  POLKey: 'POL_Name',
  PODKey: 'POD_Name',
  GoodsKey: 'Goods_CN_COUNT',
  Others: '其他',
  seaport: 'seaportName',
}

export const DomesticMarineTransportationEn = {
  // 英文
  DataStatistics: 'Dashboard',
  OrderInquiry: 'Tracking',
  SubscriptionCenter: 'Subscription',
  CurrentMonth: 'Current Month',
  CurrentQuarter: 'Current Quarter',
  CurrentYear: 'Current Year',
  Loaded: 'Loaded',
  Sailed: 'Sailed',
  Sailed2: 'Sailed',
  ArrivedatPort: 'Arrived at Port',
  ArrivedatPort2: 'Arrived at Port',
  Delivered: 'Delivered',
  Delivered2: 'Delivered',
  NumberOfTransactions: 'Total Shipments',
  vote: 'vote',
  QuantityofContainers: 'Total Containers',
  BusinessStatistics: 'Shipment',
  DestinationPortNumberofShipments: 'Destination Port (Total Shipments)',
  ContainerStatistics: 'Container (TEU)',
  DestinationPortQuantityofContainers: 'Destination Port (Total Containers)',
  JobNo: 'MW No.',
  PleaseEnterContent: 'Please Enter Content',
  CustomerCode: 'Your Ref No.',
  OrderRange: 'Booking Date',
  WaterwayShippingNumber: 'MBL No',
  ContainerType: 'CNTR Type',
  ContainerNumber: 'Container No.',
  ContainerType2: 'Type&AMT',
  Search: 'Search',
  Reset: 'Reset',
  Export: 'Export',
  DetailView: 'Detail',
  OrderNumber: 'Job No',
  OrderNumber2: 'Job No',
  BusinessType: 'Job Type',
  MM: 'MM (Multi-Trans)',
  OrderTime: 'BK Date',
  Collapse: 'Collapse',
  LoadingPortInformation: 'Loading Port',
  DestinationPortInformation: 'Destination Port',
  CargoInformation: 'Cargo',
  DownloadAttachment: 'Download',
  FileName: 'File Name',
  Creator: 'Creator',
  CreationTime: 'Creation Time',
  Operation: 'ATT',
  Download: 'Download',
  Cancel: 'Cancel',
  LoadingPort: 'POL',
  DestinationPort: 'POD',
  TotalNumberofPieces: 'PCS',
  TotalNumberofPiecesUnit: 'Unit',
  ProductNameContainerTypeQuantityofContainers: 'Product Name, Container Type, Quantity of Containers',
  GrossWeightKGS: 'GW (KGS)',
  VolumeCBM: 'Vol (CBM)',
  OrderReceived: 'Order Received',
  Packed: 'Loaded',
  Packed2: 'Packed',
  SearchErr: 'Query failed',
  Switch: 'Switch',
  MMOrderDetial: 'OceanFreight_MultimodalTransport',
  Containers: 'Container QTY',
  Goods: 'Goods',
  Goods2: 'Goods',
  SerialNumber: 'No',
  OrderStatus: 'Status',
  POLKey: 'POL_NameEn',
  PODKey: 'POD_NameEn',
  GoodsKey: 'Goods_EN_COUNT',
  Others: 'Others',
  seaport: 'remark',
}

